import Vue from 'vue';

const app = {
  state: {
    company: {},
    activeMenu: {},
  },
  mutations: {
    SET_COMPANY: (state, company) => {
      Vue.set(state, 'company', company);
    },
  },
  actions: {
    doCompanyChange({ commit }, company) {
      commit('SET_COMPANY', company);
    },

    // clear storage data
    clearStorage({ commit }) {
      return new Promise((resolve) => {
        commit('SET_COMPANY', []);
        resolve();
      });
    },
  },
};

export default app;
